import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["playlistId", "language", "showNotification", "showTooltip", "onClick", "use", "onSuccess", "render"];
import I18n from 'I18n';
import getLang from 'LearningCenterUI/utils/getLang';
import Raven from 'raven-js';
import { useMemo } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UsageTracker from '../../../utils/UsageTracker';
import { usePlaylistArchivedStatus } from '..';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const ArchivePlaylistsToggleIconMessage = ({
  isArchived
}) => isArchived ? /*#__PURE__*/_jsx(FormattedMessage, {
  message: "learningCenter.savedItems.tooltips.unsavedHoverOwner"
}) : /*#__PURE__*/_jsx(FormattedMessage, {
  message: "learningCenter.savedItems.tooltips.savedHoverOwner"
});
export const ArchivePlaylistButton = _ref => {
  let {
      playlistId,
      language = getLang(),
      showNotification = true,
      showTooltip = false,
      onClick,
      use = 'unstyled',
      onSuccess,
      render = content => /*#__PURE__*/_jsx(_Fragment, {
        children: content
      })
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isArchived,
    isLoading,
    togglePlaylistArchivedStatus
  } = usePlaylistArchivedStatus(playlistId, {
    showNotification,
    language
  });
  const handleOnClick = e => {
    if (isLoading) return;
    if (onClick) onClick(e);
    const trackingAction = isArchived ? 'unarchive-playlist' : 'archive-playlist';
    UsageTracker.track('playlistInteraction', {
      action: trackingAction,
      playlistId
    });
    togglePlaylistArchivedStatus().then(onSuccess).catch(() => {
      Raven.captureMessage(`Achievements: error archiving playlist`, {
        extra: {
          playlistId,
          language,
          isArchived
        }
      });
    });
  };
  const tooltip = useMemo(() => {
    if (!showTooltip) return null;
    return I18n.text('learningCenter.savedItems.tooltips.archiveHover');
  }, [showTooltip]);
  return /*#__PURE__*/_jsx(UITooltip, {
    placement: "right",
    title: tooltip,
    children: /*#__PURE__*/_jsx(UIButton, Object.assign({}, buttonProps, {
      disabled: isLoading,
      onClick: handleOnClick,
      use: use,
      children: render( /*#__PURE__*/_jsx(ArchivePlaylistsToggleIconMessage, {
        isArchived: isArchived
      }))
    }))
  });
};
export default ArchivePlaylistButton;